import { z } from "zod";

export const userProfileSchema = z.object({
  email: z.string(),
  is_admin: z.boolean(),
  is_anon: z.boolean(),
  history_limit: z.number(),
});

export type UserProfile = z.infer<typeof userProfileSchema>;
